import { PropsWithChildren } from 'react';

export const RealtimeIcon = ({
  children,
  className,
  backgroundColor = 'rgba(128, 128,128, 0.5)',
  size = 40,
}: PropsWithChildren<{
  className?: string;
  backgroundColor?: string;
  size?: number;
}>) => {
  return (
    <span
      className={`text-white rounded-full flex items-center justify-center ${className}`}
      style={{
        background: backgroundColor,
        backdropFilter: 'blur(6px)',
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      {children}
    </span>
  );
};
